import axios from "axios";
const myBasicAxios = () => {
  return axios.create({
    baseURL: process.env.REACT_APP_API_BASEURL,
    withCredentials: true,
  });
};

export const basicAxios = myBasicAxios();
